import api from './api';

const categoryService = {
  getTree: () => api.get('/categories'),
  getFlat: () => api.get('/categories?flat=true'),
  getBySlug: (slug, params) => api.get(`/categories/${slug}`, { params }),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  remove: (id) => api.delete(`/categories/${id}`),
  recount: () => api.post('/categories/recount'),
};

export default categoryService;
